import { Link, Outlet } from "react-router-dom";

const NavBar = (props) => {
  return (
    <>
    <nav style={{backgroundColor:"#1956b4"}} className="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top">
        <div className="container">
            <Link className="navbar-brand logo-image" to="index.html"><img src="images/logo.svg" alt="alternative"/></Link> 
            
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-awesome fas fa-bars"></span>
                <span className="navbar-toggler-awesome fas fa-times"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarsExampleDefault">
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                       <Link className="nav-link page-scroll" to="/">HOME <span className="sr-only">(current)</span></Link>
                    </li>
                    <li className="nav-item dropdown">
                        <Link className="nav-link dropdown-toggle page-scroll" to="#features" id="navbarDropdown" role="button" aria-haspopup="true" aria-expanded="false">FEATURES</Link>
                        <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                            <Link className="dropdown-item" to="/cooperative"><span className="item-text">COOPERATIVE</span></Link>
                            <div className="dropdown-items-divide-hr"></div>
                            <Link className="dropdown-item" to="/save"><span className="item-text">SAVE MONEY</span></Link>
                            <div className="dropdown-items-divide-hr"></div>
                            {/* <Link className="dropdown-item" to="privacy-policy.html"><span className="item-text">PRIVACY POLICY</span></Link> */}
                        </div>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link page-scroll" to="/pods">PODS</Link>
                    </li>
                </ul>
                <span className="nav-item">
                    <Link className="btn-outline-sm" to="/login">LOG IN</Link>
                </span>
            </div>
        </div>
    </nav>
    <Outlet/>
    </>
    
  );
}

export default NavBar;